import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { QueryOfPefAnalysisSet } from "webportalclient";
import { ODataParams, Query } from "../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { OverreadStatusIdEnum } from "../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import PefAnalysisSetListTable from "./AnalysisSetList/PefAnalysisSetListTable";
import { PefAnalysisScreen } from "./PefAnalysisScreen";

export const PefRoot = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const refreshPefAnalysisSets = async (params: ODataParams): Promise<QueryOfPefAnalysisSet> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        filter += `session/visit/subject/site/studyId eq ${study.id}`;
        return await client.client.getPefAnalysisSets('id,sessionId,started,created,analystUserName,analyst,type,status', filter, params.orderby, 'session($expand=visit($select=name,subject;$expand=subject($select=id,number,site;$expand=site($select=number,studyId))))', params.top, params.skip, undefined, true);
    }

    return (
        <Switch>
            <PrivateRoute path="/Pef/Analysis" exact permissions={[PermissionEnum.OverreadPefSession]}>
                <Query onRefresh={refreshPefAnalysisSets}
                    initialFilters={[
                        { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                    ]}
                    initialOrdering={[{ field: "created", condition: "asc" }]}
                >
                    <PefAnalysisSetListTable />
                </Query>
            </PrivateRoute>
            <PrivateRoute path="/Pef/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadPefSession, PermissionEnum.AccessSinglePefSession]}>
                <PefAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
